import { render, staticRenderFns } from "./CommissionSinglePlanSelector.vue?vue&type=template&id=200dbf3a&scoped=true&"
import script from "./CommissionSinglePlanSelector.vue?vue&type=script&lang=js&"
export * from "./CommissionSinglePlanSelector.vue?vue&type=script&lang=js&"
import style0 from "./CommissionSinglePlanSelector.vue?vue&type=style&index=0&id=200dbf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200dbf3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
